var cov_2iuftlg342 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Table/Tbody.tsx",
      hash = "b92a653d75e67356741f9c394e241f40d10b5eed",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Table/Tbody.tsx",
    statementMap: {
      "0": {
        start: {
          line: 12,
          column: 38
        },
        end: {
          line: 12,
          column: 62
        }
      },
      "1": {
        start: {
          line: 15,
          column: 2
        },
        end: {
          line: 20,
          column: 4
        }
      },
      "2": {
        start: {
          line: 16,
          column: 23
        },
        end: {
          line: 16,
          column: 42
        }
      },
      "3": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 19,
          column: 5
        }
      },
      "4": {
        start: {
          line: 18,
          column: 6
        },
        end: {
          line: 18,
          column: 41
        }
      },
      "5": {
        start: {
          line: 35,
          column: 14
        },
        end: {
          line: 66,
          column: 4
        }
      },
      "6": {
        start: {
          line: 36,
          column: 17
        },
        end: {
          line: 36,
          column: 65
        }
      },
      "7": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 83
        }
      },
      "8": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 42
        }
      },
      "9": {
        start: {
          line: 38,
          column: 26
        },
        end: {
          line: 38,
          column: 42
        }
      },
      "10": {
        start: {
          line: 40,
          column: 24
        },
        end: {
          line: 40,
          column: 27
        }
      },
      "11": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 63,
          column: 5
        }
      },
      "12": {
        start: {
          line: 42,
          column: 6
        },
        end: {
          line: 48,
          column: 7
        }
      },
      "13": {
        start: {
          line: 43,
          column: 8
        },
        end: {
          line: 47,
          column: 9
        }
      },
      "14": {
        start: {
          line: 44,
          column: 10
        },
        end: {
          line: 44,
          column: 67
        }
      },
      "15": {
        start: {
          line: 45,
          column: 15
        },
        end: {
          line: 47,
          column: 9
        }
      },
      "16": {
        start: {
          line: 46,
          column: 10
        },
        end: {
          line: 46,
          column: 74
        }
      },
      "17": {
        start: {
          line: 50,
          column: 8
        },
        end: {
          line: 52,
          column: 90
        }
      },
      "18": {
        start: {
          line: 54,
          column: 21
        },
        end: {
          line: 54,
          column: 31
        }
      },
      "19": {
        start: {
          line: 55,
          column: 6
        },
        end: {
          line: 62,
          column: 7
        }
      },
      "20": {
        start: {
          line: 56,
          column: 8
        },
        end: {
          line: 56,
          column: 48
        }
      },
      "21": {
        start: {
          line: 57,
          column: 16
        },
        end: {
          line: 57,
          column: 33
        }
      },
      "22": {
        start: {
          line: 58,
          column: 8
        },
        end: {
          line: 61,
          column: 9
        }
      },
      "23": {
        start: {
          line: 59,
          column: 10
        },
        end: {
          line: 59,
          column: 16
        }
      },
      "24": {
        start: {
          line: 60,
          column: 10
        },
        end: {
          line: 60,
          column: 31
        }
      },
      "25": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 65,
          column: 15
        }
      },
      "26": {
        start: {
          line: 68,
          column: 2
        },
        end: {
          line: 68,
          column: 12
        }
      },
      "27": {
        start: {
          line: 82,
          column: 4
        },
        end: {
          line: 82,
          column: 16
        }
      },
      "28": {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 86,
          column: 5
        }
      },
      "29": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 88,
          column: 48
        }
      },
      "30": {
        start: {
          line: 89,
          column: 4
        },
        end: {
          line: 89,
          column: 44
        }
      },
      "31": {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 90,
          column: 44
        }
      },
      "32": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 91,
          column: 52
        }
      },
      "33": {
        start: {
          line: 92,
          column: 4
        },
        end: {
          line: 92,
          column: 56
        }
      },
      "34": {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 96,
          column: 29
        }
      },
      "35": {
        start: {
          line: 97,
          column: 4
        },
        end: {
          line: 97,
          column: 21
        }
      },
      "36": {
        start: {
          line: 101,
          column: 34
        },
        end: {
          line: 101,
          column: 44
        }
      },
      "37": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 102,
          column: 80
        }
      },
      "38": {
        start: {
          line: 102,
          column: 67
        },
        end: {
          line: 102,
          column: 80
        }
      },
      "39": {
        start: {
          line: 103,
          column: 4
        },
        end: {
          line: 107,
          column: 5
        }
      },
      "40": {
        start: {
          line: 104,
          column: 6
        },
        end: {
          line: 106,
          column: 8
        }
      },
      "41": {
        start: {
          line: 105,
          column: 8
        },
        end: {
          line: 105,
          column: 25
        }
      },
      "42": {
        start: {
          line: 111,
          column: 36
        },
        end: {
          line: 111,
          column: 46
        }
      },
      "43": {
        start: {
          line: 112,
          column: 4
        },
        end: {
          line: 112,
          column: 43
        }
      },
      "44": {
        start: {
          line: 112,
          column: 37
        },
        end: {
          line: 112,
          column: 43
        }
      },
      "45": {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 113,
          column: 62
        }
      },
      "46": {
        start: {
          line: 114,
          column: 4
        },
        end: {
          line: 117,
          column: 5
        }
      },
      "47": {
        start: {
          line: 115,
          column: 6
        },
        end: {
          line: 115,
          column: 62
        }
      },
      "48": {
        start: {
          line: 116,
          column: 6
        },
        end: {
          line: 116,
          column: 12
        }
      },
      "49": {
        start: {
          line: 118,
          column: 15
        },
        end: {
          line: 118,
          column: 44
        }
      },
      "50": {
        start: {
          line: 119,
          column: 4
        },
        end: {
          line: 119,
          column: 19
        }
      },
      "51": {
        start: {
          line: 119,
          column: 13
        },
        end: {
          line: 119,
          column: 19
        }
      },
      "52": {
        start: {
          line: 120,
          column: 4
        },
        end: {
          line: 120,
          column: 30
        }
      },
      "53": {
        start: {
          line: 121,
          column: 4
        },
        end: {
          line: 121,
          column: 43
        }
      },
      "54": {
        start: {
          line: 125,
          column: 4
        },
        end: {
          line: 125,
          column: 18
        }
      },
      "55": {
        start: {
          line: 129,
          column: 4
        },
        end: {
          line: 134,
          column: 5
        }
      },
      "56": {
        start: {
          line: 131,
          column: 8
        },
        end: {
          line: 132,
          column: 37
        }
      },
      "57": {
        start: {
          line: 131,
          column: 20
        },
        end: {
          line: 131,
          column: 46
        }
      },
      "58": {
        start: {
          line: 132,
          column: 13
        },
        end: {
          line: 132,
          column: 37
        }
      },
      "59": {
        start: {
          line: 140,
          column: 71
        },
        end: {
          line: 140,
          column: 81
        }
      },
      "60": {
        start: {
          line: 142,
          column: 6
        },
        end: {
          line: 142,
          column: 112
        }
      },
      "61": {
        start: {
          line: 142,
          column: 24
        },
        end: {
          line: 142,
          column: 70
        }
      },
      "62": {
        start: {
          line: 143,
          column: 16
        },
        end: {
          line: 143,
          column: 25
        }
      },
      "63": {
        start: {
          line: 144,
          column: 4
        },
        end: {
          line: 150,
          column: 5
        }
      },
      "64": {
        start: {
          line: 145,
          column: 23
        },
        end: {
          line: 145,
          column: 54
        }
      },
      "65": {
        start: {
          line: 145,
          column: 44
        },
        end: {
          line: 145,
          column: 53
        }
      },
      "66": {
        start: {
          line: 146,
          column: 6
        },
        end: {
          line: 146,
          column: 110
        }
      },
      "67": {
        start: {
          line: 146,
          column: 32
        },
        end: {
          line: 146,
          column: 110
        }
      },
      "68": {
        start: {
          line: 147,
          column: 24
        },
        end: {
          line: 147,
          column: 102
        }
      },
      "69": {
        start: {
          line: 148,
          column: 25
        },
        end: {
          line: 148,
          column: 34
        }
      },
      "70": {
        start: {
          line: 149,
          column: 6
        },
        end: {
          line: 149,
          column: 72
        }
      },
      "71": {
        start: {
          line: 151,
          column: 4
        },
        end: {
          line: 155,
          column: 5
        }
      },
      "72": {
        start: {
          line: 152,
          column: 25
        },
        end: {
          line: 152,
          column: 38
        }
      },
      "73": {
        start: {
          line: 153,
          column: 6
        },
        end: {
          line: 153,
          column: 73
        }
      },
      "74": {
        start: {
          line: 153,
          column: 32
        },
        end: {
          line: 153,
          column: 73
        }
      },
      "75": {
        start: {
          line: 154,
          column: 6
        },
        end: {
          line: 154,
          column: 72
        }
      },
      "76": {
        start: {
          line: 156,
          column: 4
        },
        end: {
          line: 156,
          column: 20
        }
      },
      "77": {
        start: {
          line: 160,
          column: 85
        },
        end: {
          line: 160,
          column: 95
        }
      },
      "78": {
        start: {
          line: 162,
          column: 14
        },
        end: {
          line: 162,
          column: 48
        }
      },
      "79": {
        start: {
          line: 163,
          column: 4
        },
        end: {
          line: 169,
          column: 5
        }
      },
      "80": {
        start: {
          line: 164,
          column: 24
        },
        end: {
          line: 164,
          column: 45
        }
      },
      "81": {
        start: {
          line: 165,
          column: 6
        },
        end: {
          line: 167,
          column: 7
        }
      },
      "82": {
        start: {
          line: 168,
          column: 6
        },
        end: {
          line: 168,
          column: 21
        }
      },
      "83": {
        start: {
          line: 170,
          column: 4
        },
        end: {
          line: 170,
          column: 25
        }
      },
      "84": {
        start: {
          line: 171,
          column: 22
        },
        end: {
          line: 171,
          column: 25
        }
      },
      "85": {
        start: {
          line: 176,
          column: 4
        },
        end: {
          line: 189,
          column: 5
        }
      },
      "86": {
        start: {
          line: 193,
          column: 30
        },
        end: {
          line: 193,
          column: 40
        }
      },
      "87": {
        start: {
          line: 194,
          column: 4
        },
        end: {
          line: 220,
          column: 5
        }
      },
      "88": {
        start: {
          line: 197,
          column: 10
        },
        end: {
          line: 197,
          column: 39
        }
      },
      "89": {
        start: {
          line: 197,
          column: 18
        },
        end: {
          line: 197,
          column: 39
        }
      },
      "90": {
        start: {
          line: 198,
          column: 10
        },
        end: {
          line: 206,
          column: 11
        }
      },
      "91": {
        start: {
          line: 199,
          column: 12
        },
        end: {
          line: 205,
          column: 13
        }
      },
      "92": {
        start: {
          line: 207,
          column: 10
        },
        end: {
          line: 213,
          column: 11
        }
      },
      "93": {
        start: {
          line: 208,
          column: 12
        },
        end: {
          line: 212,
          column: 13
        }
      },
      "94": {
        start: {
          line: 214,
          column: 10
        },
        end: {
          line: 216,
          column: 11
        }
      },
      "95": {
        start: {
          line: 215,
          column: 12
        },
        end: {
          line: 215,
          column: 80
        }
      },
      "96": {
        start: {
          line: 217,
          column: 10
        },
        end: {
          line: 217,
          column: 31
        }
      },
      "97": {
        start: {
          line: 224,
          column: 34
        },
        end: {
          line: 224,
          column: 44
        }
      },
      "98": {
        start: {
          line: 225,
          column: 24
        },
        end: {
          line: 225,
          column: 53
        }
      },
      "99": {
        start: {
          line: 225,
          column: 42
        },
        end: {
          line: 225,
          column: 52
        }
      },
      "100": {
        start: {
          line: 226,
          column: 16
        },
        end: {
          line: 226,
          column: 39
        }
      },
      "101": {
        start: {
          line: 227,
          column: 4
        },
        end: {
          line: 227,
          column: 44
        }
      },
      "102": {
        start: {
          line: 227,
          column: 34
        },
        end: {
          line: 227,
          column: 44
        }
      },
      "103": {
        start: {
          line: 228,
          column: 4
        },
        end: {
          line: 228,
          column: 51
        }
      },
      "104": {
        start: {
          line: 232,
          column: 59
        },
        end: {
          line: 232,
          column: 69
        }
      },
      "105": {
        start: {
          line: 233,
          column: 40
        },
        end: {
          line: 233,
          column: 42
        }
      },
      "106": {
        start: {
          line: 234,
          column: 4
        },
        end: {
          line: 242,
          column: 5
        }
      },
      "107": {
        start: {
          line: 235,
          column: 16
        },
        end: {
          line: 235,
          column: 23
        }
      },
      "108": {
        start: {
          line: 236,
          column: 6
        },
        end: {
          line: 241,
          column: 7
        }
      },
      "109": {
        start: {
          line: 238,
          column: 10
        },
        end: {
          line: 238,
          column: 28
        }
      },
      "110": {
        start: {
          line: 239,
          column: 10
        },
        end: {
          line: 239,
          column: 20
        }
      },
      "111": {
        start: {
          line: 244,
          column: 4
        },
        end: {
          line: 246,
          column: 5
        }
      },
      "112": {
        start: {
          line: 245,
          column: 6
        },
        end: {
          line: 245,
          column: 29
        }
      },
      "113": {
        start: {
          line: 247,
          column: 4
        },
        end: {
          line: 247,
          column: 18
        }
      },
      "114": {
        start: {
          line: 248,
          column: 4
        },
        end: {
          line: 248,
          column: 68
        }
      }
    },
    fnMap: {
      "0": {
        name: "ignoreBorderRight",
        decl: {
          start: {
            line: 14,
            column: 9
          },
          end: {
            line: 14,
            column: 26
          }
        },
        loc: {
          start: {
            line: 14,
            column: 66
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 14
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 15,
            column: 15
          },
          end: {
            line: 15,
            column: 16
          }
        },
        loc: {
          start: {
            line: 15,
            column: 22
          },
          end: {
            line: 20,
            column: 3
          }
        },
        line: 15
      },
      "2": {
        name: "format",
        decl: {
          start: {
            line: 28,
            column: 9
          },
          end: {
            line: 28,
            column: 15
          }
        },
        loc: {
          start: {
            line: 34,
            column: 2
          },
          end: {
            line: 69,
            column: 1
          }
        },
        line: 34
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 35,
            column: 26
          },
          end: {
            line: 35,
            column: 27
          }
        },
        loc: {
          start: {
            line: 35,
            column: 38
          },
          end: {
            line: 66,
            column: 3
          }
        },
        line: 35
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 81,
            column: 2
          },
          end: {
            line: 81,
            column: 3
          }
        },
        loc: {
          start: {
            line: 81,
            column: 50
          },
          end: {
            line: 93,
            column: 3
          }
        },
        line: 81
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 95,
            column: 2
          },
          end: {
            line: 95,
            column: 3
          }
        },
        loc: {
          start: {
            line: 95,
            column: 22
          },
          end: {
            line: 98,
            column: 3
          }
        },
        line: 95
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 100,
            column: 2
          },
          end: {
            line: 100,
            column: 3
          }
        },
        loc: {
          start: {
            line: 100,
            column: 61
          },
          end: {
            line: 108,
            column: 3
          }
        },
        line: 100
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 104,
            column: 17
          },
          end: {
            line: 104,
            column: 18
          }
        },
        loc: {
          start: {
            line: 104,
            column: 23
          },
          end: {
            line: 106,
            column: 7
          }
        },
        line: 104
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 110,
            column: 2
          },
          end: {
            line: 110,
            column: 3
          }
        },
        loc: {
          start: {
            line: 110,
            column: 15
          },
          end: {
            line: 122,
            column: 3
          }
        },
        line: 110
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 124,
            column: 2
          },
          end: {
            line: 124,
            column: 3
          }
        },
        loc: {
          start: {
            line: 124,
            column: 40
          },
          end: {
            line: 126,
            column: 3
          }
        },
        line: 124
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 128,
            column: 2
          },
          end: {
            line: 128,
            column: 3
          }
        },
        loc: {
          start: {
            line: 128,
            column: 59
          },
          end: {
            line: 135,
            column: 3
          }
        },
        line: 128
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 130,
            column: 12
          },
          end: {
            line: 130,
            column: 13
          }
        },
        loc: {
          start: {
            line: 130,
            column: 21
          },
          end: {
            line: 133,
            column: 7
          }
        },
        line: 130
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 137,
            column: 2
          },
          end: {
            line: 137,
            column: 3
          }
        },
        loc: {
          start: {
            line: 137,
            column: 47
          },
          end: {
            line: 157,
            column: 3
          }
        },
        line: 137
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 142,
            column: 19
          },
          end: {
            line: 142,
            column: 20
          }
        },
        loc: {
          start: {
            line: 142,
            column: 24
          },
          end: {
            line: 142,
            column: 70
          }
        },
        line: 142
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 145,
            column: 39
          },
          end: {
            line: 145,
            column: 40
          }
        },
        loc: {
          start: {
            line: 145,
            column: 44
          },
          end: {
            line: 145,
            column: 53
          }
        },
        line: 145
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 159,
            column: 2
          },
          end: {
            line: 159,
            column: 3
          }
        },
        loc: {
          start: {
            line: 159,
            column: 44
          },
          end: {
            line: 190,
            column: 3
          }
        },
        line: 159
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 192,
            column: 2
          },
          end: {
            line: 192,
            column: 3
          }
        },
        loc: {
          start: {
            line: 192,
            column: 24
          },
          end: {
            line: 221,
            column: 3
          }
        },
        line: 192
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 196,
            column: 21
          },
          end: {
            line: 196,
            column: 22
          }
        },
        loc: {
          start: {
            line: 196,
            column: 31
          },
          end: {
            line: 218,
            column: 9
          }
        },
        line: 196
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 223,
            column: 2
          },
          end: {
            line: 223,
            column: 3
          }
        },
        loc: {
          start: {
            line: 223,
            column: 41
          },
          end: {
            line: 229,
            column: 3
          }
        },
        line: 223
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 225,
            column: 37
          },
          end: {
            line: 225,
            column: 38
          }
        },
        loc: {
          start: {
            line: 225,
            column: 42
          },
          end: {
            line: 225,
            column: 52
          }
        },
        line: 225
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 231,
            column: 2
          },
          end: {
            line: 231,
            column: 3
          }
        },
        loc: {
          start: {
            line: 231,
            column: 11
          },
          end: {
            line: 249,
            column: 3
          }
        },
        line: 231
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 237,
            column: 63
          },
          end: {
            line: 237,
            column: 64
          }
        },
        loc: {
          start: {
            line: 237,
            column: 70
          },
          end: {
            line: 240,
            column: 9
          }
        },
        line: 237
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 19,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 19,
            column: 5
          }
        }, {
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 19,
            column: 5
          }
        }],
        line: 17
      },
      "1": {
        loc: {
          start: {
            line: 37,
            column: 19
          },
          end: {
            line: 37,
            column: 83
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 37,
            column: 55
          },
          end: {
            line: 37,
            column: 79
          }
        }, {
          start: {
            line: 37,
            column: 82
          },
          end: {
            line: 37,
            column: 83
          }
        }],
        line: 37
      },
      "2": {
        loc: {
          start: {
            line: 38,
            column: 4
          },
          end: {
            line: 38,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 38,
            column: 4
          },
          end: {
            line: 38,
            column: 42
          }
        }, {
          start: {
            line: 38,
            column: 4
          },
          end: {
            line: 38,
            column: 42
          }
        }],
        line: 38
      },
      "3": {
        loc: {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 63,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 63,
            column: 5
          }
        }, {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 63,
            column: 5
          }
        }],
        line: 41
      },
      "4": {
        loc: {
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 41,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 41,
            column: 15
          }
        }, {
          start: {
            line: 41,
            column: 19
          },
          end: {
            line: 41,
            column: 26
          }
        }, {
          start: {
            line: 41,
            column: 30
          },
          end: {
            line: 41,
            column: 40
          }
        }],
        line: 41
      },
      "5": {
        loc: {
          start: {
            line: 42,
            column: 6
          },
          end: {
            line: 48,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 42,
            column: 6
          },
          end: {
            line: 48,
            column: 7
          }
        }, {
          start: {
            line: 42,
            column: 6
          },
          end: {
            line: 48,
            column: 7
          }
        }],
        line: 42
      },
      "6": {
        loc: {
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 47,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 47,
            column: 9
          }
        }, {
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 47,
            column: 9
          }
        }],
        line: 43
      },
      "7": {
        loc: {
          start: {
            line: 45,
            column: 15
          },
          end: {
            line: 47,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 15
          },
          end: {
            line: 47,
            column: 9
          }
        }, {
          start: {
            line: 45,
            column: 15
          },
          end: {
            line: 47,
            column: 9
          }
        }],
        line: 45
      },
      "8": {
        loc: {
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 52,
            column: 90
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 51,
            column: 12
          },
          end: {
            line: 51,
            column: 62
          }
        }, {
          start: {
            line: 52,
            column: 12
          },
          end: {
            line: 52,
            column: 90
          }
        }],
        line: 50
      },
      "9": {
        loc: {
          start: {
            line: 51,
            column: 12
          },
          end: {
            line: 51,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 51,
            column: 12
          },
          end: {
            line: 51,
            column: 22
          }
        }, {
          start: {
            line: 51,
            column: 26
          },
          end: {
            line: 51,
            column: 62
          }
        }],
        line: 51
      },
      "10": {
        loc: {
          start: {
            line: 52,
            column: 12
          },
          end: {
            line: 52,
            column: 90
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 52,
            column: 12
          },
          end: {
            line: 52,
            column: 22
          }
        }, {
          start: {
            line: 52,
            column: 26
          },
          end: {
            line: 52,
            column: 55
          }
        }, {
          start: {
            line: 52,
            column: 59
          },
          end: {
            line: 52,
            column: 90
          }
        }],
        line: 52
      },
      "11": {
        loc: {
          start: {
            line: 55,
            column: 6
          },
          end: {
            line: 62,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 55,
            column: 6
          },
          end: {
            line: 62,
            column: 7
          }
        }, {
          start: {
            line: 55,
            column: 6
          },
          end: {
            line: 62,
            column: 7
          }
        }],
        line: 55
      },
      "12": {
        loc: {
          start: {
            line: 55,
            column: 10
          },
          end: {
            line: 55,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 55,
            column: 10
          },
          end: {
            line: 55,
            column: 17
          }
        }, {
          start: {
            line: 55,
            column: 21
          },
          end: {
            line: 55,
            column: 27
          }
        }, {
          start: {
            line: 55,
            column: 31
          },
          end: {
            line: 55,
            column: 62
          }
        }],
        line: 55
      },
      "13": {
        loc: {
          start: {
            line: 56,
            column: 24
          },
          end: {
            line: 56,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 56,
            column: 24
          },
          end: {
            line: 56,
            column: 38
          }
        }, {
          start: {
            line: 56,
            column: 42
          },
          end: {
            line: 56,
            column: 43
          }
        }],
        line: 56
      },
      "14": {
        loc: {
          start: {
            line: 57,
            column: 16
          },
          end: {
            line: 57,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 57,
            column: 16
          },
          end: {
            line: 57,
            column: 28
          }
        }, {
          start: {
            line: 57,
            column: 32
          },
          end: {
            line: 57,
            column: 33
          }
        }],
        line: 57
      },
      "15": {
        loc: {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 102,
            column: 80
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 102,
            column: 80
          }
        }, {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 102,
            column: 80
          }
        }],
        line: 102
      },
      "16": {
        loc: {
          start: {
            line: 102,
            column: 8
          },
          end: {
            line: 102,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 102,
            column: 8
          },
          end: {
            line: 102,
            column: 19
          }
        }, {
          start: {
            line: 102,
            column: 23
          },
          end: {
            line: 102,
            column: 44
          }
        }, {
          start: {
            line: 102,
            column: 48
          },
          end: {
            line: 102,
            column: 65
          }
        }],
        line: 102
      },
      "17": {
        loc: {
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 107,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 107,
            column: 5
          }
        }, {
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 107,
            column: 5
          }
        }],
        line: 103
      },
      "18": {
        loc: {
          start: {
            line: 103,
            column: 8
          },
          end: {
            line: 103,
            column: 107
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 103,
            column: 8
          },
          end: {
            line: 103,
            column: 25
          }
        }, {
          start: {
            line: 103,
            column: 29
          },
          end: {
            line: 103,
            column: 49
          }
        }, {
          start: {
            line: 103,
            column: 53
          },
          end: {
            line: 103,
            column: 107
          }
        }],
        line: 103
      },
      "19": {
        loc: {
          start: {
            line: 112,
            column: 4
          },
          end: {
            line: 112,
            column: 43
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 112,
            column: 4
          },
          end: {
            line: 112,
            column: 43
          }
        }, {
          start: {
            line: 112,
            column: 4
          },
          end: {
            line: 112,
            column: 43
          }
        }],
        line: 112
      },
      "20": {
        loc: {
          start: {
            line: 112,
            column: 8
          },
          end: {
            line: 112,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 112,
            column: 8
          },
          end: {
            line: 112,
            column: 21
          }
        }, {
          start: {
            line: 112,
            column: 25
          },
          end: {
            line: 112,
            column: 35
          }
        }],
        line: 112
      },
      "21": {
        loc: {
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 117,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 117,
            column: 5
          }
        }, {
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 117,
            column: 5
          }
        }],
        line: 114
      },
      "22": {
        loc: {
          start: {
            line: 119,
            column: 4
          },
          end: {
            line: 119,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 119,
            column: 4
          },
          end: {
            line: 119,
            column: 19
          }
        }, {
          start: {
            line: 119,
            column: 4
          },
          end: {
            line: 119,
            column: 19
          }
        }],
        line: 119
      },
      "23": {
        loc: {
          start: {
            line: 131,
            column: 8
          },
          end: {
            line: 132,
            column: 37
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 131,
            column: 8
          },
          end: {
            line: 132,
            column: 37
          }
        }, {
          start: {
            line: 131,
            column: 8
          },
          end: {
            line: 132,
            column: 37
          }
        }],
        line: 131
      },
      "24": {
        loc: {
          start: {
            line: 142,
            column: 6
          },
          end: {
            line: 142,
            column: 112
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 142,
            column: 6
          },
          end: {
            line: 142,
            column: 71
          }
        }, {
          start: {
            line: 142,
            column: 76
          },
          end: {
            line: 142,
            column: 111
          }
        }],
        line: 142
      },
      "25": {
        loc: {
          start: {
            line: 142,
            column: 24
          },
          end: {
            line: 142,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 142,
            column: 24
          },
          end: {
            line: 142,
            column: 43
          }
        }, {
          start: {
            line: 142,
            column: 47
          },
          end: {
            line: 142,
            column: 70
          }
        }],
        line: 142
      },
      "26": {
        loc: {
          start: {
            line: 144,
            column: 4
          },
          end: {
            line: 150,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 144,
            column: 4
          },
          end: {
            line: 150,
            column: 5
          }
        }, {
          start: {
            line: 144,
            column: 4
          },
          end: {
            line: 150,
            column: 5
          }
        }],
        line: 144
      },
      "27": {
        loc: {
          start: {
            line: 146,
            column: 6
          },
          end: {
            line: 146,
            column: 110
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 146,
            column: 6
          },
          end: {
            line: 146,
            column: 110
          }
        }, {
          start: {
            line: 146,
            column: 6
          },
          end: {
            line: 146,
            column: 110
          }
        }],
        line: 146
      },
      "28": {
        loc: {
          start: {
            line: 146,
            column: 39
          },
          end: {
            line: 146,
            column: 110
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 146,
            column: 64
          },
          end: {
            line: 146,
            column: 98
          }
        }, {
          start: {
            line: 146,
            column: 101
          },
          end: {
            line: 146,
            column: 110
          }
        }],
        line: 146
      },
      "29": {
        loc: {
          start: {
            line: 147,
            column: 24
          },
          end: {
            line: 147,
            column: 102
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 147,
            column: 49
          },
          end: {
            line: 147,
            column: 62
          }
        }, {
          start: {
            line: 147,
            column: 66
          },
          end: {
            line: 147,
            column: 101
          }
        }],
        line: 147
      },
      "30": {
        loc: {
          start: {
            line: 149,
            column: 13
          },
          end: {
            line: 149,
            column: 72
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 149,
            column: 40
          },
          end: {
            line: 149,
            column: 60
          }
        }, {
          start: {
            line: 149,
            column: 63
          },
          end: {
            line: 149,
            column: 72
          }
        }],
        line: 149
      },
      "31": {
        loc: {
          start: {
            line: 149,
            column: 13
          },
          end: {
            line: 149,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 149,
            column: 13
          },
          end: {
            line: 149,
            column: 19
          }
        }, {
          start: {
            line: 149,
            column: 23
          },
          end: {
            line: 149,
            column: 37
          }
        }],
        line: 149
      },
      "32": {
        loc: {
          start: {
            line: 151,
            column: 4
          },
          end: {
            line: 155,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 151,
            column: 4
          },
          end: {
            line: 155,
            column: 5
          }
        }, {
          start: {
            line: 151,
            column: 4
          },
          end: {
            line: 155,
            column: 5
          }
        }],
        line: 151
      },
      "33": {
        loc: {
          start: {
            line: 153,
            column: 6
          },
          end: {
            line: 153,
            column: 73
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 153,
            column: 6
          },
          end: {
            line: 153,
            column: 73
          }
        }, {
          start: {
            line: 153,
            column: 6
          },
          end: {
            line: 153,
            column: 73
          }
        }],
        line: 153
      },
      "34": {
        loc: {
          start: {
            line: 154,
            column: 13
          },
          end: {
            line: 154,
            column: 72
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 154,
            column: 40
          },
          end: {
            line: 154,
            column: 60
          }
        }, {
          start: {
            line: 154,
            column: 63
          },
          end: {
            line: 154,
            column: 72
          }
        }],
        line: 154
      },
      "35": {
        loc: {
          start: {
            line: 154,
            column: 13
          },
          end: {
            line: 154,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 154,
            column: 13
          },
          end: {
            line: 154,
            column: 19
          }
        }, {
          start: {
            line: 154,
            column: 23
          },
          end: {
            line: 154,
            column: 37
          }
        }],
        line: 154
      },
      "36": {
        loc: {
          start: {
            line: 163,
            column: 4
          },
          end: {
            line: 169,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 163,
            column: 4
          },
          end: {
            line: 169,
            column: 5
          }
        }, {
          start: {
            line: 163,
            column: 4
          },
          end: {
            line: 169,
            column: 5
          }
        }],
        line: 163
      },
      "37": {
        loc: {
          start: {
            line: 197,
            column: 10
          },
          end: {
            line: 197,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 197,
            column: 10
          },
          end: {
            line: 197,
            column: 39
          }
        }, {
          start: {
            line: 197,
            column: 10
          },
          end: {
            line: 197,
            column: 39
          }
        }],
        line: 197
      },
      "38": {
        loc: {
          start: {
            line: 198,
            column: 10
          },
          end: {
            line: 206,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 198,
            column: 10
          },
          end: {
            line: 206,
            column: 11
          }
        }, {
          start: {
            line: 198,
            column: 10
          },
          end: {
            line: 206,
            column: 11
          }
        }],
        line: 198
      },
      "39": {
        loc: {
          start: {
            line: 202,
            column: 19
          },
          end: {
            line: 202,
            column: 85
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 202,
            column: 62
          },
          end: {
            line: 202,
            column: 75
          }
        }, {
          start: {
            line: 202,
            column: 78
          },
          end: {
            line: 202,
            column: 85
          }
        }],
        line: 202
      },
      "40": {
        loc: {
          start: {
            line: 202,
            column: 19
          },
          end: {
            line: 202,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 202,
            column: 19
          },
          end: {
            line: 202,
            column: 26
          }
        }, {
          start: {
            line: 202,
            column: 30
          },
          end: {
            line: 202,
            column: 59
          }
        }],
        line: 202
      },
      "41": {
        loc: {
          start: {
            line: 207,
            column: 10
          },
          end: {
            line: 213,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 207,
            column: 10
          },
          end: {
            line: 213,
            column: 11
          }
        }, {
          start: {
            line: 207,
            column: 10
          },
          end: {
            line: 213,
            column: 11
          }
        }],
        line: 207
      },
      "42": {
        loc: {
          start: {
            line: 210,
            column: 22
          },
          end: {
            line: 210,
            column: 77
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 210,
            column: 54
          },
          end: {
            line: 210,
            column: 67
          }
        }, {
          start: {
            line: 210,
            column: 70
          },
          end: {
            line: 210,
            column: 77
          }
        }],
        line: 210
      },
      "43": {
        loc: {
          start: {
            line: 214,
            column: 10
          },
          end: {
            line: 216,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 214,
            column: 10
          },
          end: {
            line: 216,
            column: 11
          }
        }, {
          start: {
            line: 214,
            column: 10
          },
          end: {
            line: 216,
            column: 11
          }
        }],
        line: 214
      },
      "44": {
        loc: {
          start: {
            line: 214,
            column: 14
          },
          end: {
            line: 214,
            column: 85
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 214,
            column: 14
          },
          end: {
            line: 214,
            column: 35
          }
        }, {
          start: {
            line: 214,
            column: 39
          },
          end: {
            line: 214,
            column: 58
          }
        }, {
          start: {
            line: 214,
            column: 62
          },
          end: {
            line: 214,
            column: 85
          }
        }],
        line: 214
      },
      "45": {
        loc: {
          start: {
            line: 227,
            column: 4
          },
          end: {
            line: 227,
            column: 44
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 227,
            column: 4
          },
          end: {
            line: 227,
            column: 44
          }
        }, {
          start: {
            line: 227,
            column: 4
          },
          end: {
            line: 227,
            column: 44
          }
        }],
        line: 227
      },
      "46": {
        loc: {
          start: {
            line: 227,
            column: 8
          },
          end: {
            line: 227,
            column: 32
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 227,
            column: 8
          },
          end: {
            line: 227,
            column: 20
          }
        }, {
          start: {
            line: 227,
            column: 24
          },
          end: {
            line: 227,
            column: 32
          }
        }],
        line: 227
      },
      "47": {
        loc: {
          start: {
            line: 244,
            column: 4
          },
          end: {
            line: 246,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 244,
            column: 4
          },
          end: {
            line: 246,
            column: 5
          }
        }, {
          start: {
            line: 244,
            column: 4
          },
          end: {
            line: 246,
            column: 5
          }
        }],
        line: 244
      },
      "48": {
        loc: {
          start: {
            line: 244,
            column: 8
          },
          end: {
            line: 244,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 244,
            column: 8
          },
          end: {
            line: 244,
            column: 23
          }
        }, {
          start: {
            line: 244,
            column: 27
          },
          end: {
            line: 244,
            column: 35
          }
        }],
        line: 244
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0, 0],
      "11": [0, 0],
      "12": [0, 0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0, 0],
      "17": [0, 0],
      "18": [0, 0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Table/Tbody.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import immer from 'immer';
import { PureComponent } from '../component';
import { compareColumns } from '../utils/shallowEqual';
import { getKey } from '../utils/uid';
import Tr from './Tr';
import { tableClass } from './styles';
import { isFunc } from '../utils/is';
export var RENDER_COL_GROUP_EVENT = (cov_2iuftlg342.s[0]++, 'RENDER_COL_GROUP_EVENT');

function ignoreBorderRight(rows) {
  cov_2iuftlg342.f[0]++;
  cov_2iuftlg342.s[1]++;
  rows.forEach(function (row) {
    cov_2iuftlg342.f[1]++;
    var lastColumn = (cov_2iuftlg342.s[2]++, row[row.length - 1]);
    cov_2iuftlg342.s[3]++;

    if (lastColumn) {
      cov_2iuftlg342.b[0][0]++;
      cov_2iuftlg342.s[4]++;
      lastColumn.ignoreBorderRight = true;
    } else {
      cov_2iuftlg342.b[0][1]++;
    }
  });
}

function format(columns, data, nextRow, index, expandKeys) {
  cov_2iuftlg342.f[2]++;
  var row = (cov_2iuftlg342.s[5]++, columns.map(function (col, i) {
    cov_2iuftlg342.f[3]++;
    var cell = (cov_2iuftlg342.s[6]++, {
      index: index,
      data: data,
      expandKeys: expandKeys
    });
    cov_2iuftlg342.s[7]++;
    cell.colSpan = typeof col.colSpan === 'function' ? (cov_2iuftlg342.b[1][0]++, col.colSpan(data, index)) : (cov_2iuftlg342.b[1][1]++, 1);
    cov_2iuftlg342.s[8]++;

    if (cell.colSpan < 1) {
      cov_2iuftlg342.b[2][0]++;
      cov_2iuftlg342.s[9]++;
      cell.colSpan = 1;
    } else {
      cov_2iuftlg342.b[2][1]++;
    }

    var _ref = (cov_2iuftlg342.s[10]++, col),
        rowSpan = _ref.rowSpan;

    cov_2iuftlg342.s[11]++;

    if ((cov_2iuftlg342.b[4][0]++, rowSpan) && (cov_2iuftlg342.b[4][1]++, nextRow) && (cov_2iuftlg342.b[4][2]++, nextRow[i])) {
      cov_2iuftlg342.b[3][0]++;
      cov_2iuftlg342.s[12]++;

      if (col.type !== 'checkbox') {
        cov_2iuftlg342.b[5][0]++;
        cov_2iuftlg342.s[13]++;

        if (typeof col.render === 'string') {
          cov_2iuftlg342.b[6][0]++;
          cov_2iuftlg342.s[14]++;
          cell.content = data[col.render];
        } else {
          cov_2iuftlg342.b[6][1]++;
          cov_2iuftlg342.s[15]++;

          if (isFunc(col.render)) {
            cov_2iuftlg342.b[7][0]++;
            cov_2iuftlg342.s[16]++;
            cell.content = col.render(data, index);
          } else {
            cov_2iuftlg342.b[7][1]++;
          }
        }
      } else {
        cov_2iuftlg342.b[5][1]++;
      }

      var isEqual = (cov_2iuftlg342.s[17]++, rowSpan === true ? (cov_2iuftlg342.b[8][0]++, (cov_2iuftlg342.b[9][0]++, nextRow[i]) && (cov_2iuftlg342.b[9][1]++, cell.content === nextRow[i].content)) : (cov_2iuftlg342.b[8][1]++, (cov_2iuftlg342.b[10][0]++, nextRow[i]) && (cov_2iuftlg342.b[10][1]++, typeof rowSpan === 'function') && (cov_2iuftlg342.b[10][2]++, rowSpan(data, nextRow[i].data))));
      var nextTd = (cov_2iuftlg342.s[18]++, nextRow[i]);
      cov_2iuftlg342.s[19]++;

      if ((cov_2iuftlg342.b[12][0]++, isEqual) && (cov_2iuftlg342.b[12][1]++, nextTd) && (cov_2iuftlg342.b[12][2]++, nextTd.colSpan === cell.colSpan)) {
        cov_2iuftlg342.b[11][0]++;
        cov_2iuftlg342.s[20]++;
        cell.rowSpan = ((cov_2iuftlg342.b[13][0]++, nextTd.rowSpan) || (cov_2iuftlg342.b[13][1]++, 1)) + 1;
        var j = (cov_2iuftlg342.s[21]++, (cov_2iuftlg342.b[14][0]++, cell.colSpan) || (cov_2iuftlg342.b[14][1]++, 1));
        cov_2iuftlg342.s[22]++;

        while (j) {
          cov_2iuftlg342.s[23]++;
          j -= 1;
          cov_2iuftlg342.s[24]++;
          nextRow[i + j] = null;
        }
      } else {
        cov_2iuftlg342.b[11][1]++;
      }
    } else {
      cov_2iuftlg342.b[3][1]++;
    }

    cov_2iuftlg342.s[25]++;
    return cell;
  }));
  cov_2iuftlg342.s[26]++;
  return row;
}

var Tbody =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Tbody, _PureComponent);

  var _super = _createSuper2(Tbody);

  function Tbody(props) {
    var _this;

    _classCallCheck(this, Tbody);

    cov_2iuftlg342.f[4]++;
    cov_2iuftlg342.s[27]++;
    _this = _super.call(this, props);
    _this.colgroupSetted = void 0;
    _this.keys = void 0;
    _this.body = void 0;
    cov_2iuftlg342.s[28]++;
    _this.state = {
      expand: {}
    };
    cov_2iuftlg342.s[29]++;
    _this.bodyRender = _this.bodyRender.bind(_assertThisInitialized(_this));
    cov_2iuftlg342.s[30]++;
    _this.bindBody = _this.bindBody.bind(_assertThisInitialized(_this));
    cov_2iuftlg342.s[31]++;
    _this.renderTr = _this.renderTr.bind(_assertThisInitialized(_this));
    cov_2iuftlg342.s[32]++;
    _this.handleExpand = _this.handleExpand.bind(_assertThisInitialized(_this));
    cov_2iuftlg342.s[33]++;
    _this.findExpandFunc = _this.findExpandFunc.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Tbody, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_2iuftlg342.f[5]++;
      cov_2iuftlg342.s[34]++;

      _get(_getPrototypeOf(Tbody.prototype), "componentDidMount", this).call(this);

      cov_2iuftlg342.s[35]++;
      this.bodyRender();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      cov_2iuftlg342.f[6]++;

      var _ref2 = (cov_2iuftlg342.s[36]++, this.props),
          onScrollTop = _ref2.onScrollTop,
          data = _ref2.data;

      cov_2iuftlg342.s[37]++;

      if ((cov_2iuftlg342.b[16][0]++, onScrollTop) && (cov_2iuftlg342.b[16][1]++, prevProps.data.length) && (cov_2iuftlg342.b[16][2]++, data.length === 0)) {
        cov_2iuftlg342.b[15][0]++;
        cov_2iuftlg342.s[38]++;
        onScrollTop();
      } else {
        cov_2iuftlg342.b[15][1]++;
      }

      cov_2iuftlg342.s[39]++;

      if ((cov_2iuftlg342.b[18][0]++, this.props.resize) || (cov_2iuftlg342.b[18][1]++, !this.colgroupSetted) || (cov_2iuftlg342.b[18][2]++, !compareColumns(prevProps.columns, this.props.columns))) {
        cov_2iuftlg342.b[17][0]++;
        cov_2iuftlg342.s[40]++;
        setTimeout(function () {
          cov_2iuftlg342.f[7]++;
          cov_2iuftlg342.s[41]++;

          _this2.bodyRender();
        });
      } else {
        cov_2iuftlg342.b[17][1]++;
      }
    }
  }, {
    key: "bodyRender",
    value: function bodyRender() {
      cov_2iuftlg342.f[8]++;

      var _ref3 = (cov_2iuftlg342.s[42]++, this.props),
          onBodyRender = _ref3.onBodyRender,
          datum = _ref3.datum;

      cov_2iuftlg342.s[43]++;

      if ((cov_2iuftlg342.b[20][0]++, !onBodyRender) || (cov_2iuftlg342.b[20][1]++, !this.body)) {
        cov_2iuftlg342.b[19][0]++;
        cov_2iuftlg342.s[44]++;
        return;
      } else {
        cov_2iuftlg342.b[19][1]++;
      }

      cov_2iuftlg342.s[45]++;
      datum.unsubscribe(RENDER_COL_GROUP_EVENT, this.bodyRender);
      cov_2iuftlg342.s[46]++;

      if (this.body.clientHeight === 0) {
        cov_2iuftlg342.b[21][0]++;
        cov_2iuftlg342.s[47]++;
        datum.subscribe(RENDER_COL_GROUP_EVENT, this.bodyRender);
        cov_2iuftlg342.s[48]++;
        return;
      } else {
        cov_2iuftlg342.b[21][1]++;
      }

      var tr = (cov_2iuftlg342.s[49]++, this.body.querySelector('tr'));
      cov_2iuftlg342.s[50]++;

      if (!tr) {
        cov_2iuftlg342.b[22][0]++;
        cov_2iuftlg342.s[51]++;
        return;
      } else {
        cov_2iuftlg342.b[22][1]++;
      }

      cov_2iuftlg342.s[52]++;
      this.colgroupSetted = true;
      cov_2iuftlg342.s[53]++;
      onBodyRender(tr.querySelectorAll('td'));
    }
  }, {
    key: "bindBody",
    value: function bindBody(el) {
      cov_2iuftlg342.f[9]++;
      cov_2iuftlg342.s[54]++;
      this.body = el;
    }
  }, {
    key: "handleExpand",
    value: function handleExpand(key, render) {
      cov_2iuftlg342.f[10]++;
      cov_2iuftlg342.s[55]++;
      this.setState(immer(function (draft) {
        cov_2iuftlg342.f[11]++;
        cov_2iuftlg342.s[56]++;

        if (render) {
          cov_2iuftlg342.b[23][0]++;
          cov_2iuftlg342.s[57]++;
          draft.expand[key] = render;
        } else {
          cov_2iuftlg342.b[23][1]++;
          cov_2iuftlg342.s[58]++;
          delete draft.expand[key];
        }
      }));
    }
  }, {
    key: "findExpandFunc",
    value: function findExpandFunc(key, i) {
      cov_2iuftlg342.f[12]++;

      //
      // (rowData: DataItem, index?: number) => ReactNode
      var _ref4 = (cov_2iuftlg342.s[59]++, this.props),
          columns = _ref4.columns,
          expandKeys = _ref4.expandKeys,
          data = _ref4.data,
          externalExpandRender = _ref4.externalExpandRender,
          index = _ref4.index;

      var expandableObj = (cov_2iuftlg342.s[60]++, (cov_2iuftlg342.b[24][0]++, columns.find(function (c) {
        cov_2iuftlg342.f[13]++;
        cov_2iuftlg342.s[61]++;
        return (cov_2iuftlg342.b[25][0]++, c.type === 'expand') || (cov_2iuftlg342.b[25][1]++, c.type === 'row-expand');
      })) || (cov_2iuftlg342.b[24][1]++, {}));
      var idx = (cov_2iuftlg342.s[62]++, i + index);
      cov_2iuftlg342.s[63]++;

      if (expandKeys) {
        cov_2iuftlg342.b[26][0]++;
        var expanded = (cov_2iuftlg342.s[64]++, expandKeys.find(function (k) {
          cov_2iuftlg342.f[14]++;
          cov_2iuftlg342.s[65]++;
          return k === key;
        }));
        cov_2iuftlg342.s[66]++;

        if (externalExpandRender) {
          cov_2iuftlg342.b[27][0]++;
          cov_2iuftlg342.s[67]++;
          return expanded !== undefined ? (cov_2iuftlg342.b[28][0]++, externalExpandRender(data[i], idx)) : (cov_2iuftlg342.b[28][1]++, undefined);
        } else {
          cov_2iuftlg342.b[27][1]++;
        }

        var expandObj = (cov_2iuftlg342.s[68]++, expanded !== undefined ? (cov_2iuftlg342.b[29][0]++, expandableObj) : (cov_2iuftlg342.b[29][1]++, {}));

        var _ref5 = (cov_2iuftlg342.s[69]++, expandObj),
            render = _ref5.render;

        cov_2iuftlg342.s[70]++;
        return (cov_2iuftlg342.b[31][0]++, render) && (cov_2iuftlg342.b[31][1]++, isFunc(render)) ? (cov_2iuftlg342.b[30][0]++, render(data[i], idx)) : (cov_2iuftlg342.b[30][1]++, undefined);
      } else {
        cov_2iuftlg342.b[26][1]++;
      }

      cov_2iuftlg342.s[71]++;

      if (this.state.expand[key]) {
        cov_2iuftlg342.b[32][0]++;

        var _ref6 = (cov_2iuftlg342.s[72]++, expandableObj),
            _render = _ref6.render;

        cov_2iuftlg342.s[73]++;

        if (externalExpandRender) {
          cov_2iuftlg342.b[33][0]++;
          cov_2iuftlg342.s[74]++;
          return externalExpandRender(data[i], idx);
        } else {
          cov_2iuftlg342.b[33][1]++;
        }

        cov_2iuftlg342.s[75]++;
        return (cov_2iuftlg342.b[35][0]++, _render) && (cov_2iuftlg342.b[35][1]++, isFunc(_render)) ? (cov_2iuftlg342.b[34][0]++, _render(data[i], idx)) : (cov_2iuftlg342.b[34][1]++, undefined);
      } else {
        cov_2iuftlg342.b[32][1]++;
      }

      cov_2iuftlg342.s[76]++;
      return undefined;
    }
  }, {
    key: "renderTr",
    value: function renderTr(row, i) {
      cov_2iuftlg342.f[15]++;

      var _ref7 = (cov_2iuftlg342.s[77]++, this.props),
          columns = _ref7.columns,
          keygen = _ref7.keygen,
          data = _ref7.data,
          sorter = _ref7.sorter,
          index = _ref7.index,
          expandKeys = _ref7.expandKeys,
          colgroup = _ref7.colgroup,
          other = _objectWithoutProperties(_ref7, ["columns", "keygen", "data", "sorter", "index", "expandKeys", "colgroup"]);

      var key = (cov_2iuftlg342.s[78]++, getKey(data[i], keygen, index + i));
      cov_2iuftlg342.s[79]++;

      if (this.keys[key]) {
        cov_2iuftlg342.b[36][0]++;
        var converted = (cov_2iuftlg342.s[80]++, "".concat(key, "-").concat(index + i));
        cov_2iuftlg342.s[81]++;
        console.warn("Tr has same key: (".concat(key, "). Already converted with (").concat(converted, "), Please check the 'keygen' property."));
        cov_2iuftlg342.s[82]++;
        key = converted;
      } else {
        cov_2iuftlg342.b[36][1]++;
      }

      cov_2iuftlg342.s[83]++;
      this.keys[key] = true;
      var originKey = (cov_2iuftlg342.s[84]++, key); // seems to be useless code
      // if (sorter && sorter.order) {
      //   key = `${key}-${sorter.index}-${sorter.order}`
      // }

      cov_2iuftlg342.s[85]++;
      return (
        /*#__PURE__*/
        React.createElement(Tr, Object.assign({}, other, {
          index: i + index,
          key: key,
          originKey: originKey,
          data: row,
          rowData: data[i],
          columns: columns,
          rowKey: key,
          onExpand: this.handleExpand,
          expandRender: this.findExpandFunc(originKey, i),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 177,
            columnNumber: 7
          }
        }))
      );
    }
  }, {
    key: "renderPlaceholderTr",
    value: function renderPlaceholderTr() {
      var _this3 = this;

      cov_2iuftlg342.f[16]++;

      var _ref8 = (cov_2iuftlg342.s[86]++, this.props),
          columns = _ref8.columns,
          data = _ref8.data;

      cov_2iuftlg342.s[87]++;
      return (
        /*#__PURE__*/
        React.createElement("tr", {
          className: tableClass('placeholder-tr'),
          key: "so-placeholder-".concat(new Date().getTime()),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 195,
            columnNumber: 7
          }
        }, columns.map(function (v, i) {
          cov_2iuftlg342.f[17]++;
          cov_2iuftlg342.s[88]++;

          if (!v) {
            cov_2iuftlg342.b[37][0]++;
            cov_2iuftlg342.s[89]++;
            return (
              /*#__PURE__*/
              React.createElement("td", {
                key: i,
                __self: _this3,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 197,
                  columnNumber: 26
                }
              })
            );
          } else {
            cov_2iuftlg342.b[37][1]++;
          }

          cov_2iuftlg342.s[90]++;

          if (v.minWidth) {
            cov_2iuftlg342.b[38][0]++;
            cov_2iuftlg342.s[91]++;
            return (
              /*#__PURE__*/
              React.createElement("td", {
                key: i,
                style: {
                  padding: 0,
                  border: 'none'
                },
                __self: _this3,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 200,
                  columnNumber: 15
                }
              },
              /*#__PURE__*/
              React.createElement("div", {
                style: {
                  width: v.minWidth
                },
                __self: _this3,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 201,
                  columnNumber: 17
                }
              }, (cov_2iuftlg342.b[40][0]++, v.title) && (cov_2iuftlg342.b[40][1]++, typeof v.title === 'function') ? (cov_2iuftlg342.b[39][0]++, v.title(data)) : (cov_2iuftlg342.b[39][1]++, v.title)))
            );
          } else {
            cov_2iuftlg342.b[38][1]++;
          }

          cov_2iuftlg342.s[92]++;

          if (v.title) {
            cov_2iuftlg342.b[41][0]++;
            cov_2iuftlg342.s[93]++;
            return (
              /*#__PURE__*/
              React.createElement("td", {
                key: i,
                __self: _this3,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 209,
                  columnNumber: 15
                }
              },
              /*#__PURE__*/
              React.createElement("div", {
                __self: _this3,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 210,
                  columnNumber: 17
                }
              }, typeof v.title === 'function' ? (cov_2iuftlg342.b[42][0]++, v.title(data)) : (cov_2iuftlg342.b[42][1]++, v.title)))
            );
          } else {
            cov_2iuftlg342.b[41][1]++;
          }

          cov_2iuftlg342.s[94]++;

          if ((cov_2iuftlg342.b[44][0]++, v.type === 'checkbox') || (cov_2iuftlg342.b[44][1]++, v.type === 'expand') || (cov_2iuftlg342.b[44][2]++, v.type === 'row-expand')) {
            cov_2iuftlg342.b[43][0]++;
            cov_2iuftlg342.s[95]++;
            return (
              /*#__PURE__*/
              React.createElement("td", {
                key: i,
                className: tableClass('placeholder-checkbox'),
                __self: _this3,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 215,
                  columnNumber: 20
                }
              })
            );
          } else {
            cov_2iuftlg342.b[43][1]++;
          }

          cov_2iuftlg342.s[96]++;
          return (
            /*#__PURE__*/
            React.createElement("td", {
              key: i,
              __self: _this3,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 217,
                columnNumber: 18
              }
            })
          );
        }))
      );
    }
  }, {
    key: "renderTrs",
    value: function renderTrs(rows) {
      cov_2iuftlg342.f[18]++;

      var _ref9 = (cov_2iuftlg342.s[97]++, this.props),
          columns = _ref9.columns,
          colgroup = _ref9.colgroup;

      var minWidthSup = (cov_2iuftlg342.s[98]++, columns.find(function (d) {
        cov_2iuftlg342.f[19]++;
        cov_2iuftlg342.s[99]++;
        return d.minWidth;
      }));
      var trs = (cov_2iuftlg342.s[100]++, rows.map(this.renderTr));
      cov_2iuftlg342.s[101]++;

      if ((cov_2iuftlg342.b[46][0]++, !minWidthSup) || (cov_2iuftlg342.b[46][1]++, colgroup)) {
        cov_2iuftlg342.b[45][0]++;
        cov_2iuftlg342.s[102]++;
        return trs;
      } else {
        cov_2iuftlg342.b[45][1]++;
      }

      cov_2iuftlg342.s[103]++;
      return [this.renderPlaceholderTr()].concat(trs);
    }
  }, {
    key: "render",
    value: function render() {
      cov_2iuftlg342.f[20]++;

      var _ref10 = (cov_2iuftlg342.s[104]++, this.props),
          index = _ref10.index,
          data = _ref10.data,
          columns = _ref10.columns,
          expandKeys = _ref10.expandKeys,
          bordered = _ref10.bordered;

      var rows = (cov_2iuftlg342.s[105]++, []);
      cov_2iuftlg342.s[106]++;

      for (var i = data.length - 1; i >= 0; i--) {
        var d = (cov_2iuftlg342.s[107]++, data[i]);
        cov_2iuftlg342.s[108]++;
        rows.unshift(format(columns, d, rows[0], index + i, expandKeys).map(function (col) {
          cov_2iuftlg342.f[21]++;
          cov_2iuftlg342.s[109]++;
          delete col.content;
          cov_2iuftlg342.s[110]++;
          return col;
        }));
      }

      cov_2iuftlg342.s[111]++;

      if ((cov_2iuftlg342.b[48][0]++, rows.length > 0) && (cov_2iuftlg342.b[48][1]++, bordered)) {
        cov_2iuftlg342.b[47][0]++;
        cov_2iuftlg342.s[112]++;
        ignoreBorderRight(rows);
      } else {
        cov_2iuftlg342.b[47][1]++;
      }

      cov_2iuftlg342.s[113]++;
      this.keys = {};
      cov_2iuftlg342.s[114]++;
      return (
        /*#__PURE__*/
        React.createElement("tbody", {
          ref: this.bindBody,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 248,
            columnNumber: 12
          }
        }, this.renderTrs(rows))
      );
    }
  }]);

  return Tbody;
}(PureComponent);

export default Tbody;